import { useMemo } from "react";
import { CPTResult } from "types/tests";
import { calculateCPTAssessment, CPTAssessment } from "../utils/CPTAssessmentUtils";

export function useCPTAssessment(testResult: CPTResult | undefined): CPTAssessment | null {
  return useMemo(() => calculateCPTAssessment(testResult), [testResult]);
}
